import {type FormEventHandler, type ReactNode, useState} from 'react';
import {CloseCircleIcon, SearchIcon} from '@prtimes-basis/icons';
import styles from './search-screen.module.css';

type Props = {
  readonly popularKeywordsNode: ReactNode;
};

export function SearchScreen({popularKeywordsNode}: Props) {
  const [keyword, setKeyword] = useState('');

  const onSubmit = ((event) => {
    if (keyword === '') {
      event.preventDefault();
    }
  }) satisfies FormEventHandler;

  return (
    <div className={styles.screen}>
      <div className={styles.container}>
        <form
          role='search'
          method='GET'
          action='/main/action.php'
          className={styles.inputWrapper}
          onSubmit={onSubmit}
        >
          <input type='hidden' name='run' value='html' />
          <input type='hidden' name='page' value='searchkey' />
          <SearchIcon className={styles.searchIcon} variant='gray' />
          <input
            className={styles.input}
            name='search_word'
            type='text'
            value={keyword}
            placeholder='キーワードや企業名で検索'
            onChange={(event) => {
              setKeyword(event.target.value);
            }}
          />
          <CloseCircleIcon
            className={styles.closeIcon}
            variant='gray'
            onClick={() => {
              setKeyword('');
            }}
          />
          <input type='hidden' name='search_pattern' value='1' />
        </form>

        {popularKeywordsNode}
      </div>
    </div>
  );
}
